/* eslint max-len: 0 */

import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';

import isEmpty from 'lodash/isEmpty';

import Manager from '../shared/manager';
import Copy from '../shared/copy-to-clipboard';
import TrackerFieldsList from './components/tracker-fields-list';

lessRequire('modules/user-api/main.less');

const volatiles = {
	companyName: process.env.CPA_ENV === 'everad' ? 'Everad CPA 2 API' : 'RocketProfit API',
	apiDomain: process.env.CPA_ENV === 'everad' ? 'everad.com' : 'rocketprofit.com'
};

const isRocket = process.env.CPA_ENV === 'rocket';

const php = `<?php
session_start();

//Данные для передачи
$ip = $_SERVER['REMOTE_ADDR'];
$name = $_POST['name'];
$phone = $_POST['phone'];
$campaign_id = 111111;

$order = array(
	'campaign_id' => $campaign_id,
	'ip' => $ip,
	'name' => $name,
	'phone' => $phone,
	'country_code' => SK,
);

$orderSerialized = "";
foreach ($_POST as $key => $value) {
	if ($value != '') {
		$order[$key] = $value;
		$orderSerialized .= "'" . $key . "':'" . $value . "',";
	}
}

$orderSerialized = "{" . $orderSerialized . "},\n";
$ordersFile = fopen("orders.txt", "a");
fwrite($ordersFile, $orderSerialized);
fclose($ordersFile);

$order['is_smart_form'] = true;
// Define ip
if (!empty($_SERVER['HTTP_CF_CONNECTING_IP'])) {
$ip =  $_SERVER['HTTP_CF_CONNECTING_IP'];
}  elseif (!empty($_SERVER['HTTP_X_REAL_IP'])) {
$ip =  $_SERVER['HTTP_X_REAL_IP'];
} elseif (!empty($_SERVER['HTTP_X_FORWARDED_FOR'])) {
$ip = $_SERVER['HTTP_X_FORWARDED_FOR'];
} else {
$ip =  $_SERVER['REMOTE_ADDR'];
}

$ips = explode(",", $ip);
$order['ip'] = trim($ips[0]);

$parsed_referer = parse_url($_SERVER['HTTP_REFERER'], PHP_URL_QUERY);
parse_str($parsed_referer, $referer_query);

$ch = curl_init();
$submit_url = 'https://tracker.${volatiles.apiDomain}/conversion/new';
$_SESSION['submit_url'] = $submit_url;

curl_setopt($ch, CURLOPT_URL, $submit_url );
curl_setopt($ch, CURLOPT_RETURNTRANSFER, 1 );
curl_setopt($ch, CURLOPT_POST,           1 );
curl_setopt($ch, CURLOPT_POSTFIELDS,     http_build_query(array_merge($referer_query, $order)) );
curl_setopt($ch, CURLOPT_HTTPHEADER,     array('Content-Type: application/x-www-form-urlencoded'));

$result = curl_exec ($ch);
$error = false;

if ($result === 0) {
    $error = "Timeout! Everad CPA API didn't respond within default period!";
} else {
$httpCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);
if ($httpCode === 400) {
    $error = "Order data is invalid! Order is not accepted!";
} else if ($httpCode === 423) {
    header('Location: ' . $_SERVER['HTTP_REFERER'] . '?is_pending_order_check_failed=true');
    exit();
} else if ($httpCode === 401) {
    $error = "Order is not accepted! No campaign_id.";
} else if ($httpCode === 403) {
    $error = "Order is not accepted! Restricted GEO. Please submit your order from another GEO.";
} else if ($httpCode !== 200) {
    $error = "Order is not accepted! Invalid or incomplete data. Please contact support.";
} else {
     foreach (json_decode($result, true) as $key => $value) {
	if ($key === "id") {
      $_SESSION['conversion_id'] = $value;
	}
   }
}}
if ($error) {header('Location: ' . $_SERVER['HTTP_REFERER'] . '?is_blacklist_error=true');
exit();
}
?>
`;

const phpCode = `$ip = $_SERVER['REMOTE_ADDR'];
$name = $_POST['name'];
$phone = $_POST['phone'];
$campaign_id = 1111111;

$params = array(
	'campaign_id' => $campaign_id,
	'ip' => $ip,
	'name' => $name,
	'phone' => $phone,
	'country_code' => 'SK',
);
`;

const fbScript = `<!-- Facebook Pixel Code -->
<img
	height="1"
	width="1"
	style="display:none"
	src="https://www.facebook.com/tr?id=<?php echo $_POST["sid1"]?>&ev=Lead&noscript=1"
/>
<!-- DO NOT MODIFY -->
<!-- End Facebook Pixel Code -->`;

const web = (intl) => {
	return `<form method="post" action="subscribe1.php" >
	<input name="name" placeholder="Tvoje meno" required> 
	<input type="tel" placeholder="+420 999 999 999" name="phone" required="required">
	<input type="hidden" name="campaign_id" value="1111111">
	<input type="hidden" name="country_code" value="SK">
</form>
`;
};

const Main = renderViewsState(props => {
	const { intl } = props;
	return (
		<div className="dashboard container container__with-columns">

			<div className="column_left api font-proxima-nova-regular">
				<div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">
							{intl('Прием заказов через')} {volatiles.companyName}
						</h2>
					</div>
				</div>

				<div className="api-anchors">
					<a href='#' className='anchorBtn' onClick={e => scrollToElement(e, 'server')}>
						<span>{intl('Отправка с сервера')}<div className="border"></div></span><span className="after"></span>
					</a>
					<a href='#' className='anchorBtn' onClick={e => scrollToElement(e, 'web')}>
						<span>{intl('Отправка с веб-страницы')}<div className="border"></div></span><span className="after"></span>
					</a>
					<a href='#' className='anchorBtn' onClick={e => scrollToElement(e, 'php')}>
						<span>{intl('Пример на PHP')}<div className="border"></div></span><span className="after"></span>
					</a>
					<a href='#' className='anchorBtn' onClick={e => scrollToElement(e, 'instruction-fb')}>
						<span>{intl('FB Pixel')}<div className="border"></div></span><span className="after"></span>
					</a>
				</div>

				<div className="container__content">
					<div className="container__content-title">
						<h4 className="font-proxima-nova-semibold"  id="server">
							{intl('Отправка с сервера')}
						</h4>
					</div>
					<p>
						{intl('Для отправки заказа по API, отправьте POST запрос')}&nbsp; {intl('на')}&nbsp;
					</p>
					<p>
						<code className="api-code-simple">{`https://tracker.${volatiles.apiDomain}/conversion/new`}</code>
					</p>
					<p>
						{intl('Запрос должен быть с заголовком')}&nbsp;
					</p>
					<p>
						<code className="api-code-simple">{intl('Content-Type: application/x-www-form-urlencoded')}&nbsp;</code>
					</p>
					<p className="no-margin">
						{intl('В теле запроса ожидаются следующие данные:')}
					</p>
					<p>
						<code className="api-code-simple">
							{intl('campaign_id=500401&ip=54.67.12.1&name=John&phone=74521231314&country_code=SK')}&nbsp;
						</code>
						{intl('где:')}
					</p>
					<TrackerFieldsList {...props} />
					<p className="margin-top-25">
						{intl('В случае успешной обработки лида, сервер ответит кодом 200.')}
						{intl('В случае редиректа код ответа будет 302.')}
						{intl(
							'В случае возникновения ошибки сервер вернет код 400 и в теле ответа будет перечень ошибок валидации.'
						)}
					</p>

					<div className="container__content-title">
						<h4 className="font-proxima-nova-semibold"  id="web">{intl('Отправка с веб-страницы')}</h4>
					</div>
					<p className="no-margin">
						{intl('Для отправки с веб-страницы (лендинга)')}
					</p>
					<div className="copier">
						<Copy copyText={web(intl)} tooltipText={intl('Скопировать')} intl={intl}/>
					</div>
					<div className="triangle" />
					<div className="api-code no-margin">
						<pre><code>
							<p className="font-courier">
								{web(intl)}
							</p>
						</code></pre>
					</div>
					<div>
						<p>
							<em>{intl('*subscribe1.php - наш файл-обработчик', volatiles.apiDomain)}</em>
						</p>
					</div>
					<div className="api-code">
						<pre><code>
							<p className="font-courier">
								{phpCode}
							</p>
						</code></pre>
					</div>

					<div className="container__content-title">
						<h4 className="font-proxima-nova-semibold"  id="php">
							{intl('Пример файла-обработчика на PHP')}
						</h4>
					</div>
					<div className="copier">
						<Copy copyText={php} tooltipText={intl('Скопировать')} intl={intl} />
					</div>
					<div className="triangle" />
					<div className="api-code">
						<pre><code><p className="font-courier">{php}</p></code></pre>
					</div>
					{
						isRocket &&
						<div className="container__content-title instruction-title">
							<h4 className="font-proxima-nova-semibold"  id="instruction">{intl('Видео-инструкция')}</h4>
						</div>
					}
					{
						isRocket &&
						<div className="copier instruction-copier">
							<Copy
								copyText={`https://www.youtube.com/watch?v=${intl.language==='ru'?'EB43MVV_3iw':'rBC9a8nOJfI'}`}
								tooltipText={intl('Копировать')}
								intl={intl} />
						</div>
					}
					{
						isRocket &&
						<iframe
							className="instruction-youtube"
							src={`https://www.youtube.com/embed/${intl.language==='ru'?'EB43MVV_3iw':'rBC9a8nOJfI'}?showinfo=0&amp`}
							allow="autoplay; encrypted-media"
							allowFullScreen
							allowTransparency = 'true'
							frameBorder={0}>
						</iframe>
					}
					<div id="instruction-fb">
						<div className="container__content-title">
							<h4 className="font-proxima-nova-semibold"  id="server">
								{intl('Добавление пикселя facebook на скачанный ленд')}
							</h4>
						</div>
						<ul className="small-list">
							<li>
								&nbsp;{intl('Необходимо скачать ленд в формате php из сохраненного потока.')}
							</li>
							<li>
								&nbsp;{intl('Файл index.html переименовать на index.php.')}
							</li>
							<li>
								&nbsp;{intl('С помощью редактора кода или блокнота открываем index.php.')}&nbsp;
								{intl('По поиску находим')}
								<pre className="display-initial code-background"><code> {'</form>'}</code></pre>
								{` ${intl('и перед ним добавляем строчку')}`}
								<div>
									<pre><code><p className="font-courier code-background">
										{`<input type="hidden" name="sid1" value="<?php echo $_GET['pixel'];?>" /> `}
									</p></code></pre>
								</div>
								<div>&nbsp;{`${intl('сохраняем')}`}</div>
							</li>
							<li>
								&nbsp;{intl('В файле subscribe1.php находим строчку:')}&nbsp;
								<div>
									<pre><code><p className="font-courier code-background">
										{`<input type="hidden" name="sid5" value ="<?php echo $_POST['sid5']; ?>"/> `}
									</p></code></pre>
								</div>
								&nbsp;{intl('Под нее добавляем:')}&nbsp;
								<div>
									<pre><code><p className="font-courier code-background">
										{`<input type="hidden" name="sid1" value ="<?php echo $_POST['sid1']; ?>"/>`}
									</p></code></pre>
								</div>
							</li>
							<li>
								&nbsp;{intl(`В файле  subscribe1.php, после тега`)}&nbsp;
								<pre className="display-initial code-background">
									<code>
										{'</script>'}
									</code>
								</pre>
								{` ${intl(`перед`)} `}
								<pre className="display-initial code-background">
									<code>
										{'</body>'}
									</code>
								</pre>
								&nbsp;{intl(`(это внизу страницы) добавляем:`)}&nbsp;
								<div>
									<pre><code><p className="font-courier code-background">
										{fbScript}
									</p></code></pre>
								</div>
							</li>
							<li>
								&nbsp;{intl('Сохраняем все внесенные изменения и загружаем лендинг к себе на хостинг/в трекер.')}&nbsp;
								{intl(`К рекламной ссылке дописываем`)}&nbsp;
								<pre className="display-initial code-background">
									<code>
										{'?pixel=111111111'}
									</code>
								</pre>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div className="column_right">
				{ !isEmpty(props.manager) && <Manager data={props.manager} user={props.user} intl={intl} />  }
			</div>
		</div>
	);
});

const scrollToElement = (e, elementId) => {
	e.preventDefault();
	window.scrollTo(0, document.getElementById(elementId).offsetTop);
};

export default connect(
	state => ({
		data: selectors.getData(state),
		user: selectors.getUserData(state),
		manager: selectors.getManager(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/user-api/main.js